import type { AxiosError, AxiosResponse } from "axios";
import { useMutation, useQuery } from "@tanstack/react-query";

import { useMutate } from "@/shared/hooks";
import type {
  SendSMSRequest,
  SMSExportRequest,
  SMSExportResponse,
} from "./api.dto";
import { apiInstance } from "@/shared/api";

export const useSendSMS = () => {
  const { mutationFn, onError, onSuccess } = useMutate({
    method: "post",
    url: "/sms",
    toast: {
      success: {
        description: "СМСки отправлены.",
      },
    },
  });

  return useMutation<AxiosResponse, AxiosError, SendSMSRequest, Response>({
    mutationKey: ["sendSMS"],
    mutationFn,
    onError,
    onSuccess,
  });
};

export const useSMSAccount = () => {
  return useQuery({
    queryKey: ["smsAccount"],
    queryFn: async () => {
      const { data } = await apiInstance.get("/sms/account");

      return data;
    },
  });
};

export const useSMSExport = () => {
  return useMutation<SMSExportResponse, AxiosError, SMSExportRequest>({
    mutationKey: ["smsExport"],
    mutationFn: async (data) => {
      const response = await apiInstance.get<Blob>(
        "/sms/history/export/xlsx",
        data,
        false,
        { responseType: "blob" },
      );

      return response.data;
    },
  });
};
